<template>
  <section class="clients-case-studies-section pt-120 pb-100">
    <div class="container">
      <div class="row justify-content-center">
        <div class="col-xl-6 col-lg-8">
          <div class="section-title text-center mb-70">
            <h2>{{ content.header.title }}</h2>
            <p>{{ content.header.description }}</p>
          </div>
        </div>
      </div>

      <div class="case-studies-grid">
        <div class="case-study-item" v-for="(study, index) in content.caseStudies" :key="index">
          <div class="case-study-card">
            <div class="case-study-header">
              <div class="case-study-icon">
                <i :class="study.icon"></i>
              </div>
              <div class="case-study-meta">
                <span class="case-study-category">{{ study.category }}</span>
                <span class="case-study-duration">{{ study.duration }}</span>
              </div>
            </div>
            
            <div class="case-study-content">
              <h3>{{ study.title }}</h3>
              <p class="case-study-description">{{ study.description }}</p>
              
              <div class="case-study-stats">
                <div class="stat-item" v-for="(stat, statIndex) in study.stats" :key="statIndex">
                  <div class="stat-value">{{ stat.value }}</div>
                  <div class="stat-label">{{ stat.label }}</div>
                </div>
              </div>
              
              <div class="case-study-technologies">
                <span class="tech-tag" v-for="(tech, techIndex) in study.technologies" :key="techIndex">
                  {{ tech }}
                </span>
              </div>
            </div>
            
            <div class="case-study-footer">
              <a href="#" class="case-study-link">
                View Full Case Study <i class="fas fa-arrow-right"></i>
              </a>
            </div>
          </div>
        </div>
      </div>

    </div>
  </section>
</template>

<script>
export default {
  name: 'TechItsClientsCaseStudiesComp',
  props: {
    content: {
      type: Object,
      required: true
    }
  }
}
</script>

<style scoped>
/* Import Google Fonts */
@import url("https://fonts.googleapis.com/css2?family=Archivo:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900&family=Open+Sans:ital,wght@0,300;0,400;0,500;0,600;0,700;0,800;1,300;1,400;1,500;1,600;1,700;1,800&display=swap");

/* Clients & Case Studies Section */
.clients-case-studies-section {
  position: relative;
  z-index: 1;
  padding-top: 120px;
  padding-bottom: 100px;
  background: linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%);
}

.section-title {
  margin-bottom: 70px;
}

.section-title h2 {
  font-size: 40px;
  font-weight: 700;
  color: #2c3e50;
  margin-bottom: 20px;
  font-family: "Archivo", sans-serif;
}

.section-title p {
  font-size: 16px;
  color: #6c757d;
  line-height: 1.8;
}

.section-title.text-center {
  text-align: center;
}

.case-studies-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(400px, 1fr));
  gap: 40px;
  margin-bottom: 80px;
}

.case-study-item {
  position: relative;
}

.case-study-card {
  background: #fff;
  border-radius: 20px;
  padding: 40px;
  box-shadow: 0 15px 35px rgba(0, 0, 0, 0.1);
  transition: all 0.3s ease;
  border: 1px solid rgba(246, 236, 79, 0.2);
  height: 100%;
  display: flex;
  flex-direction: column;
  position: relative;
  overflow: hidden;
}

.case-study-card::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 4px;
  background: linear-gradient(90deg, #f6ec4f, #f4d03f);
}

.case-study-card:hover {
  transform: translateY(-10px);
  box-shadow: 0 25px 50px rgba(0, 0, 0, 0.15);
  border-color: #f6ec4f;
}

.case-study-header {
  display: flex;
  align-items: center;
  margin-bottom: 25px;
}

.case-study-icon {
  width: 60px;
  height: 60px;
  background: linear-gradient(135deg, #f6ec4f, #f4d03f);
  border-radius: 15px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 20px;
  font-size: 24px;
  color: #2c3e50;
}

.case-study-meta {
  display: flex;
  flex-direction: column;
  gap: 5px;
}

.case-study-category {
  background: rgba(246, 236, 79, 0.2);
  color: #2c3e50;
  padding: 4px 12px;
  border-radius: 12px;
  font-size: 12px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.case-study-duration {
  color: #6c757d;
  font-size: 14px;
  font-weight: 500;
}

.case-study-content {
  flex: 1;
  margin-bottom: 25px;
}

.case-study-content h3 {
  font-size: 24px;
  font-weight: 700;
  color: #2c3e50;
  margin-bottom: 15px;
  line-height: 1.3;
  font-family: "Archivo", sans-serif;
}

.case-study-description {
  color: #6c757d;
  line-height: 1.6;
  margin-bottom: 25px;
  font-size: 15px;
}

.case-study-stats {
  display: flex;
  gap: 20px;
  margin-bottom: 25px;
  padding: 20px;
  background: rgba(246, 236, 79, 0.1);
  border-radius: 12px;
}

.stat-item {
  text-align: center;
  flex: 1;
}

.stat-value {
  font-size: 28px;
  font-weight: 700;
  color: #f6ec4f;
  line-height: 1;
  margin-bottom: 5px;
  font-family: "Archivo", sans-serif;
}

.stat-label {
  font-size: 12px;
  color: #6c757d;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  font-weight: 500;
}

.case-study-technologies {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  margin-bottom: 20px;
}

.tech-tag {
  background: rgba(44, 62, 80, 0.1);
  color: #2c3e50;
  padding: 6px 12px;
  border-radius: 15px;
  font-size: 12px;
  font-weight: 500;
  border: 1px solid rgba(44, 62, 80, 0.2);
}

.case-study-footer {
  margin-top: auto;
}

.case-study-link {
  color: #f6ec4f;
  text-decoration: none;
  font-weight: 600;
  display: inline-flex;
  align-items: center;
  gap: 8px;
  transition: all 0.3s ease;
  font-size: 14px;
}

.case-study-link:hover {
  color: #2c3e50;
  gap: 12px;
}


/* Responsive Design */
@media only screen and (max-width: 991px) {
  .clients-case-studies-section {
    padding: 80px 0;
  }
}

@media only screen and (max-width: 767px) {
  .clients-case-studies-section {
    padding: 60px 0;
  }
  
  .section-title h2 {
    font-size: 32px;
  }
  
  .case-studies-grid {
    grid-template-columns: 1fr;
    gap: 30px;
  }
  
  .case-study-card {
    padding: 30px;
  }
  
  .case-study-content h3 {
    font-size: 20px;
  }
  
  .case-study-stats {
    flex-direction: column;
    gap: 15px;
  }
  
}

@media only screen and (max-width: 399px) {
  .clients-case-studies-section {
    padding: 40px 0;
  }
  
  .section-title h2 {
    font-size: 28px;
  }
  
  .case-study-card {
    padding: 25px;
  }
  
}
</style>
